import { render, staticRenderFns } from "./AnswerModal.vue?vue&type=template&id=0e2b673e&scoped=true&"
import script from "./AnswerModal.vue?vue&type=script&lang=js&"
export * from "./AnswerModal.vue?vue&type=script&lang=js&"
import style0 from "./AnswerModal.vue?vue&type=style&index=0&id=0e2b673e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2b673e",
  null
  
)

export default component.exports